import type { ApiRoute, NoBody, NoPathParams } from "../api"
import type { ModelInformationView } from "../vehicleDetails/overview/modelInformation/ModelInformationView"

export interface GetModelInformationQueryParams {
	"inventory-id": string
}

export const getModelInformationRoute: ApiRoute<
	NoPathParams,
	GetModelInformationQueryParams,
	NoBody,
	ModelInformationView
> = {
	buildUrl: () => "/model-information",
	method: "get",
	path: "/model-information",
}
